import { useEffect } from 'react';

interface SEOConfig {
  title: string;
  description: string;
  keywords?: string;
  lang?: string;
  canonical?: string;
  canonicalPath?: string;
}

export default function useSEO({ title, description, keywords, lang = 'zh-TW', canonical, canonicalPath }: SEOConfig) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    const setMeta = (name: string, content: string, attr: 'name' | 'property' = 'name') => {
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
    const resolvedCanonical = canonical || (canonicalPath ? `${siteUrl}${canonicalPath}` : `${siteUrl}/`);

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('og:url', resolvedCanonical, 'property');
    setMeta('og:locale', lang.replace('-', '_'), 'property');

    setMeta('twitter:card', 'summary_large_image', 'name');
    setMeta('twitter:title', title, 'name');
    setMeta('twitter:description', description, 'name');

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = resolvedCanonical;

    return () => {
      document.documentElement.lang = 'zh-TW';
    };
  }, [title, description, keywords, lang, canonical, canonicalPath]);
}